import { Component, OnInit, Input, ViewChild, OnDestroy, ElementRef, Renderer2, AfterViewInit } from "@angular/core";
import { RouteInfo } from "./sidebar.metadata";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { ConfigService } from '../services/config.service';
import { LayoutService } from '../services/layout.service';
import { Subscription } from 'rxjs';
import { ToastrService } from "ngx-toastr";
import { isNumeric } from 'rxjs/util/isNumeric';


import { UserService } from "../auth/user.service";
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  animations: customAnimations
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('toggleIcon', { static: false }) toggleIcon: ElementRef;
  public menuItems: any[];
  depth: number;
  activeTitle: string;
  activeTitles: string[] = [];
  expanded: boolean;
  nav_collapsed_open = false;
  logoUrl = 'assets/img/logo-light-symbol.svg';

  public config: any = {};
  layoutSub: Subscription;
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private configService: ConfigService,
    private layoutService: LayoutService,
    public toastr: ToastrService,
    public user: UserService,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
      this.expanded = true;
    }
    this.layoutSub = layoutService.customizerChangeEmitted$.subscribe(
      options => {
        if (options) {
          if (options.bgColor) {
            if (options.bgColor === 'white') {
              this.logoUrl = 'assets/img/logo-light-symbol.svg';
            }
            else {
              this.logoUrl = 'assets/img/logo-light-symbol.svg';
            }
          }
          if (options.compactMenu === true) {
            this.expanded = false;
            this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
            this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
            this.nav_collapsed_open = true;
          }
          else if (options.compactMenu === false) {
            this.expanded = true;
            this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
            this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
            this.nav_collapsed_open = false;
          }
        }
      });
  
  }
  ngOnInit(): void {
    throw new Error("Method not implemented.");
  }
  name=''
  check() {

    this.config = this.configService.templateConf;

    this.logoUrl = 'assets/img/logo-light-symbol.svg';
      console.log('!checktoken', localStorage.getItem('_token').toString(), localStorage.getItem('userId').toString())
    if (!localStorage.getItem('_token').toString() ) {
    
      localStorage.setItem('_token', null);
      localStorage.setItem('userId', null);
      this.router.navigate(['/pages/login']);
    } else {
      console.log('checktoken')
      this.user.checktoken(localStorage.getItem('_token').toString(), localStorage.getItem('userId')).map(res => res.json()).subscribe((res) => {

        console.log(res)
        if (res.success) {

          localStorage.setItem('type', res.type)
          localStorage.setItem('country', res.country);
         this.name= res.user[0].email;
          if (Number(res.type) == 10) {
            this.menuItems = this.AdminMenu;
          }
          if (Number(res.type) == 1) {
            this.menuItems = this.hrMenu;
          }
          if (Number(res.type) == 2) {
            this.menuItems = this.DeMenu;
          }
          if (Number(res.type) == 3) {
            this.menuItems = this.DesMenu;
          }
          if (Number(res.type) == 4) {
            this.menuItems = this.SMenu;
          
            
          }
          if (Number(res.type) == 13) {
            this.menuItems = this.emMenu;


          }
          this.toastr.info('Connected')
        } else {
          localStorage.setItem('_token', null);
          localStorage.setItem('userId', 'false');
          this.router.navigate(['/pages/login']);
          this.toastr.error(res.message, 'Failed Login_')

        }
      })
    }



  }
  ngAfterViewInit() {
    this.check();
    setTimeout(() => {
   
      if (this.config.layout.sidebar.collapsed != undefined) {
        if (this.config.layout.sidebar.collapsed === true) {
          this.expanded = false;
          this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = true;
        }
        else if (this.config.layout.sidebar.collapsed === false) {
          this.expanded = true;
          this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = false;
        }
      }
    }, 0);
  }
  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }
  toggleSlideInOut() {
    this.expanded = !this.expanded;
  }
  handleToggle(titles) {
    this.activeTitles = titles;
  }
  // NGX Wizard - skip url change
  ngxWizardFunction(path: string) {
    if (path.indexOf("forms/ngx") !== -1)
      this.router.navigate(["forms/ngx/wizard"], { skipLocationChange: false });
  }
  AdminMenu = [
    {
      path: '/dashboard/dashboard1', title: 'Dashboard', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    {
      path: '', title: 'Users', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
      submenu: [
        { path: '/uikit/typography', title: 'Admins', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/uikit/syntaxhighlighter', title: 'HR', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/uikit/helperclasses', title: 'Data Entry', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/uikit/textutilities', title: 'Data Entry Supervisor ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/forms/basic', title: 'Sales ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },

      ]
    }, {
      path: '', title: 'app Architecture', icon: 'icon-game-controller', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
        { path: '/uikit/feather', title: 'Countries ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/uikit/font-awesome', title: 'Regions', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/uikit/simple-line', title: 'Categories', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/uikit/grids', title: 'Sub Categories / Area', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        { path: '/player', title: 'Sub Area', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
      ]
    },
    {
      path: '', title: 'aqar', icon: 'icon-globe', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
      submenu: [
        { path: '/components/lists', title: 'Add Real estate', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
        {
          path: '/components/switch', title: 'Real estate', icon: 'icon-check', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
        }
      ]
    },
    { path: '/components/nouislider', title: 'Slider', icon: 'icon-clock', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },

    { path: '/components/editor', title: 'Company', icon: 'icon-globe', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/components/select', title: 'Article', icon: 'icon-doc', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '/taskboard-ngrx', title: 'Settings', icon: 'ft-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '', title: 'Logout', icon: 'ft-life-buoy', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: [] },
  ];
  hrMenu = [
    {
      path: '/dashboard/dashboard1', title: 'Dashboard', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },


    { path: '/uikit/helperclasses', title: 'Data Entry', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/uikit/textutilities', title: 'Data Entry Supervisor ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/forms/basic', title: 'Sales ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '/taskboard-ngrx', title: 'Settings', icon: 'ft-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '', title: 'Logout', icon: 'ft-life-buoy', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: [] },
  ];
  DeMenu = [
    {
      path: '/dashboard/dashboard1', title: 'Dashboard', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    { path: '/components/lists', title: 'Add Aqar', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    {
      path: '/components/switch', title: 'Real estate', icon: 'icon-check', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    // { path: '/taskboard-ngrx', title: 'Settings', icon: 'ft-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '', title: 'Logout', icon: 'ft-life-buoy', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: [] },
  ];
  emMenu = [
    { path: '/uikit/feather', title: 'Countries ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/uikit/font-awesome', title: 'Regions', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/uikit/simple-line', title: 'Categories', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/uikit/grids', title: 'Sub Categories / Area', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/player', title: 'Sub Area', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
  ];
  DesMenu = [
    {
      path: '/dashboard/dashboard1', title: 'Dashboard', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    // { path: '/uikit/feather', title: 'Countries ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '/uikit/font-awesome', title: 'Regions', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '/uikit/simple-line', title: 'Categories', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '/uikit/grids', title: 'Sub Categories / Area', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '/player', title: 'Sub Area', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/uikit/helperclasses', title: 'Data Entry', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '/uikit/textutilities', title: 'Data Entry Supervisor ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/forms/basic', title: 'Sales ', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    { path: '/components/lists', title: 'Add Aqar', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    {
      path: '/components/switch', title: 'Real estate', icon: 'icon-check', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    // { path: '/taskboard-ngrx', title: 'Settings', icon: 'ft-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '', title: 'Logout', icon: 'ft-life-buoy', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: [] },
  ];
  SMenu = [
    {
      path: '/dashboard/dashboard1', title: 'Dashboard', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },

    { path: '/components/lists', title: 'Add Aqar', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    {
      path: '/components/switch', title: 'Real estate', icon: 'icon-check', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    // { path: '/taskboard-ngrx', title: 'Settings', icon: 'ft-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    // { path: '', title: 'Logout', icon: 'ft-life-buoy', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: [] },
  ];


}
